/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface ValidateAccountDomain$Request {
    accountId: number;
    domain: string;
}

export interface ValidateAccountDomain$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const validateAccountDomainRequest = createAction<PayloadData<void, ValidateAccountDomain$Request>>('VALIDATE_ACCOUNT_DOMAIN__VALIDATE_ACCOUNT_DOMAIN__REQUEST');
export const validateAccountDomainSuccess = createAction<PayloadData<void, ValidateAccountDomain$Request>>('VALIDATE_ACCOUNT_DOMAIN__VALIDATE_ACCOUNT_DOMAIN__SUCCESS');
export const validateAccountDomainFailure = createAction<PayloadData<Error, ValidateAccountDomain$Request, true>>('VALIDATE_ACCOUNT_DOMAIN__VALIDATE_ACCOUNT_DOMAIN__FAILURE');

export const validateAccountDomainActions = [
    validateAccountDomainRequest,
    validateAccountDomainSuccess,
    validateAccountDomainFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {string} meta.domain
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const validateAccountDomain = (meta: ValidateAccountDomain$Request, config?: ValidateAccountDomain$Config) => {
    const TRANSPORT_GET_PARAMS = {
        domain: meta.domain,
    };
    return {
        CALL_API: {
            types: validateAccountDomainActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/domains/validations`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

